var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPricelistIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.286,
    height: 20,
    viewBox: "0 0 14.286 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "solid_pound-sign",
    "data-name": "solid pound-sign",
    d: "M13.75,46.286H11.719a.536.536,0,0,0-.536.536v2.27H5.714V43.429h3.75A.536.536,0,0,0,10,42.893V41.107a.536.536,0,0,0-.536-.536H5.714V37.734a2.557,2.557,0,0,1,2.759-2.548,5.157,5.157,0,0,1,2.574.841.535.535,0,0,0,.7-.12l1.272-1.585a.535.535,0,0,0-.095-.763A7.672,7.672,0,0,0,8.39,32c-3.656,0-6.247,2.355-6.247,5.623v2.948H.893a.536.536,0,0,0-.536.536v1.786a.536.536,0,0,0,.536.536h1.25v5.714H.536A.536.536,0,0,0,0,49.679v1.786A.536.536,0,0,0,.536,52H13.75a.536.536,0,0,0,.536-.536V46.821A.536.536,0,0,0,13.75,46.286Z",
    transform: "translate(0 -32)",
    fill: "#fc1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricelistIcon);
export default __webpack_public_path__ + "static/media/pricelist-icon.bdc332d2f82cd82f73f59ad59c1fe9df.svg";
export { ForwardRef as ReactComponent };